import { createUUID } from '../../../utils';

export class LinkFactory {
  /**
   * Creates a link object from a raw edge.
   * @param {WorkflowEdge} link - The raw edge object.
   * @returns {WorkflowEdge} The link object with a default label if not provided.
   */
  static fromRawEdge(link) {
    return { ...link, label: link.label || '', metadata: link.metadata || {} };
  }

  /**
   * Creates a new edge object.
   * @param {Object} params - The parameters for creating the edge.
   * @param {string} [params.edge_uid] - The unique identifier of the edge. Defaults to a new UUID.
   * @param {string} params.source - The source node ID.
   * @param {string} params.target - The target node ID.
   * @param {string} [params.label] - The label of the edge. Defaults to an empty string.
   * @returns {WorkflowEdge} The created edge object.
   */
  static createEdge({ edge_uid = createUUID(), source, target, label = '', metadata = {} }) {
    return { edge_uid, source, target, label, metadata };
  }
}
